<script setup>
const emit = defineEmits(['add']);

const addLabel = () => {
  emit('add');
};
</script>

<template>
  <button
    class="inline-flex items-center gap-1 px-3 py-1 mb-0.5 ltr:mr-0.5 rtl:ml-0.5 rounded-full text-xs cursor-pointer bg-n-slate-3 text-n-slate-11 hover:bg-n-slate-4 border-0"
    @click="addLabel"
  >
    <span class="i-lucide-plus w-3 h-3" />
    Adicionar
  </button>
</template>
